import { pilot } from '../../../services/serviceInstances';

export const validateDate = (dateString, cancelToken) =>
  pilot.get(`document/validate/date/?value=${dateString}`, {
    cancelToken: cancelToken,
  });
